import React, { useEffect, useState } from 'react';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';
// import Heading from '@amzn/meridian/heading';
// import Divider from '@amzn/meridian/divider';
import { CorePage, CorePageTitle } from '$/components';
import { RootUri } from '$/features/routes';
import {
  CoreTabGroupSwitch,
  CoreTabRoute,
} from '@amzn/dots-core-ui/dist/components/CoreTabGroupSwitch';
import { getHamsClient, getHost } from '$/api/client/client';
import { useParams } from 'react-router-dom';
import { HostData } from '@amzn/dots-host-agent-management-service-client';
import { useAuth } from '@amzn/dots-core-ui';
import Loader from '@amzn/meridian/loader';
import {
  HostStatusTag,
  HostLastUpdatedTag,
  HostEditButton,
  HostDevicesList,
  HostSettingsButton,
  HostTestrunsList,
} from './components';

export function HostDetailPage(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const [host, setHost] = useState<HostData | undefined>(undefined);
  const auth = useAuth();

  useEffect(() => {
    async function fetchHost() {
      const hamsClient = await getHamsClient(auth);

      const response = await getHost({ accountName: id }, hamsClient);
      setHost(response?.host);
    }

    fetchHost();
  }, [auth, id]);

  return (
    <CorePage
      title={host?.accountName}
      breadcrumbs={[{ title: 'Host Agents', href: RootUri }]}
      header={
        <>
          <Row>
            {host?.status && <HostStatusTag status={host.status} />}
            {host?.dateModified && (
              <HostLastUpdatedTag dateModified={host.dateModified} />
            )}
          </Row>
          <Row widths={['fill', 'fit']}>
            <Column>
              {host?.accountName && <CorePageTitle title={host.accountName} />}
              <Column spacing="100">
                {host?.ownerGroup && <Text>Owner: {host.ownerGroup}</Text>}
              </Column>
            </Column>
            {host && (
              <Row alignmentHorizontal="end">
                <HostEditButton host={host} />
                <HostSettingsButton host={host} />
              </Row>
            )}
          </Row>
        </>
      }
    >
      {host === undefined ? (
        <Loader />
      ) : (
        <CoreTabGroupSwitch>
          <CoreTabRoute key="details" label="Details" path="details">
            <Column spacing="500" />
            {/* {host?.lab?.name || host?.location?.name ? (
              <Column spacing="500">
                <Column spacingInset="400" type="outline">
                  <Heading level={3}>LMS</Heading>
                  <Divider />
                  <Column spacingInset="400">
                    {host?.location?.name && (
                      <Text>Location: {host.location.name}</Text>
                    )}
                    {host?.lab?.name && <Text>Lab: {host.lab.name}</Text>}
                  </Column>
                </Column>
              </Column>
            ) : (
              ''
            )} */}
            <Text>Todo: details here</Text>
          </CoreTabRoute>
          <CoreTabRoute key="devices" label="Devices" path="devices">
            <HostDevicesList host={host} />
          </CoreTabRoute>
          <CoreTabRoute key="testruns" label="Testruns" path="testruns">
            <HostTestrunsList host={host!} />
          </CoreTabRoute>
        </CoreTabGroupSwitch>
      )}
    </CorePage>
  );
}
